import React from 'react';
import { FormattedMessage } from 'react-intl';

import { CTAButton } from '@/globalStyles';

import { FooterWrapper, GroupWrapper, ButtonWrapper } from './styles';

const Footer = (props) => {
  const {
    onCloseClick,
    isLastWizardPage,
    currentPage,
    onNextClick,
    onBackClick,
    onSaveClick,
    isSmartphone
  } = props;

  return (
    <FooterWrapper isLastWizardPage={isLastWizardPage}>
      {
        (currentPage > 0 || (isLastWizardPage && isSmartphone) || !isSmartphone) && (
          <GroupWrapper isLastWizardPage={isLastWizardPage}>
            {
              currentPage > 0 && (
                <ButtonWrapper onClick={onCloseClick} isHidden={!onCloseClick} >
                  <CTAButton
                      disabled={!onBackClick}
                      onClick={onBackClick}
                      className='secondary'
                    >
                      <FormattedMessage id="app.editor.wizard.back" defaultMessage="Back" />
                  </CTAButton>
                </ButtonWrapper>
              )
            }
            {
              isLastWizardPage && (
                <ButtonWrapper>
                  <CTAButton
                      disabled={!onNextClick}
                      onClick={onNextClick}
                      className='secondary'
                      primary={isSmartphone}
                      >
                        <FormattedMessage id="app.editor.wizard.editor" defaultMessage="Marking Editor" />
                  </CTAButton>
                </ButtonWrapper>
              )
            }
          </GroupWrapper>
        )
      }
      <GroupWrapper isLastWizardPage={isLastWizardPage}>
        {
          isLastWizardPage ? 
            <ButtonWrapper>
              <CTAButton
                disabled={!onSaveClick}
                onClick={onSaveClick}
                primary
                className='primary'
                >
                  <FormattedMessage id="app.footer.button.save" defaultMessage="Save" />
              </CTAButton>
            </ButtonWrapper>
            :
            <ButtonWrapper>
              <CTAButton
                  disabled={!onNextClick}
                  onClick={onNextClick}
                  primary
                  className='primary'
                >
                  <FormattedMessage id="app.editor.wizard.next" defaultMessage="Next" />
              </CTAButton>
            </ButtonWrapper>
        }
      </GroupWrapper>
    </FooterWrapper>
  );
};

export default React.memo(Footer);
